import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
var sizeMap = {
  small: 15,
  medium: 20,
  large: 25
};
export default function SvgIcon(_ref) {
  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      viewBox = _ref.viewBox,
      nodeRef = _ref.nodeRef,
      other = _objectWithoutProperties(_ref, ["children", "color", "size", "style", "viewBox", "nodeRef"]);

  var resultSize = sizeMap[size] || size;

  var resultStyle = _extends({
    width: resultSize,
    height: resultSize,
    display: 'inline-block',
    userSelect: 'none',
    fill: color
  }, style);

  var resultViewBox = typeof viewBox === 'function' ? viewBox(resultSize) : viewBox;
  var resultChildren = typeof children === 'function' ? children(resultSize) : children;
  return React.createElement("svg", _extends({}, other, {
    ref: nodeRef,
    viewBox: resultViewBox,
    style: resultStyle
  }), resultChildren);
}
SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Дополнительный класс для иконки
   */
  className: PropTypes.string,

  /**
   * Дополнительные инлайновые стили для иконки
   */
  style: PropTypes.object,

  /**
   * Цвет иконки
   */
  color: PropTypes.string,

  /**
   * Элементы, которые отрисуются внутри svg-элемента,
   * ожидается `ReactElement` или функция возвращающая его и получающая размер как аргумент `size => ReactElement`
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Размер иконки. Может быть строкой или значением в пикселях
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.number, PropTypes.string]),

  /**
   * Атрибут viewBox svg-элемента
   * ожидается строка или функция возвращающая строку и получающая размер как аргумент `size => string`
   */
  viewBox: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Коллбэк для передачи ссылки на ноду svg элемента
   */
  nodeRef: PropTypes.func
} : {};
SvgIcon.defaultProps = {
  viewBox: '0 0 20 20',
  size: 'medium',
  style: {},
  color: 'black'
};